import { useContext } from 'react'
import { CartProvider } from '../../../context/CartProvider'
import { ViddyLPContext } from '../../../context/viddyLPContext'
import { CoreProvider } from '../../providers/CoreProvider'
import { FullScreenVideoContextProvider } from '../../providers/FullScreenVideoContextProvider'
import { HLSReloader } from '../../providers/HLSReloader'
import { VideoContextProvider } from '../../providers/VideoContextProvider'
import { HLSProvider } from '../../shared/HlsProvider'
import { QueryParamContext } from '../../../context/QueryParamContextProvider'
import { ShopifyCartProvider } from '../../../context/ShopifyCartProvider'
import { ProductLayoutProvider } from '../../../context/ProductLayoutContext'
import { useRouter } from 'next/router'
import ScrollingLP from './scrolling/ScrollingLP'

const FALLBACK_CART_PROVIDER = false

const PersonalizedLP: React.FC = () => {
    const { landingPage } = useContext(ViddyLPContext)
    const { SHOP_CART } = useContext(QueryParamContext)
    const router = useRouter()

    function switchToFallbackCartProvider(
        error: Error,
        isWarn: boolean = false,
        details?: string,
    ) {
        const logFunction = isWarn ? console.warn : console.error
        logFunction(
            `Switching to fallback cart provider due to an error ${details ? ` - Additional details: ${details}` : ''}`,
            error,
        )
        // change the URL
        const url = new URL(window.location.href)
        url.searchParams.set('shopCart', `${FALLBACK_CART_PROVIDER}`)
        router.push(url)
    }

    const contents = (
        <CoreProvider playlist={landingPage.defaultPlaylist || null}>
            <VideoContextProvider>
                <HLSProvider>
                    <FullScreenVideoContextProvider>
                        <ProductLayoutProvider>
                            <HLSReloader />
                            <ScrollingLP />
                        </ProductLayoutProvider>
                    </FullScreenVideoContextProvider>
                </HLSProvider>
            </VideoContextProvider>
        </CoreProvider>
    )

    if (SHOP_CART) {
        return (
            <ShopifyCartProvider
                switchToFallbackCartProvider={switchToFallbackCartProvider}
            >
                {contents}
            </ShopifyCartProvider>
        )
    }
    return <CartProvider>{contents}</CartProvider>
}

export default PersonalizedLP
